import { Navigate, useLocation } from "react-router-dom";

// Maps the old split routes to the unified /models tabs so bookmarks
// and stray links keep working:
//   /battery-models/*        -> /models/battery/*
//   /cell-models/specs/*     -> /models/cell/*
//   /cell-models/*           -> /models/cell/*
const BATTERY_PREFIX = /^\/battery-models/;
const CELL_SPECS_PREFIX = /^\/cell-models\/specs/;
const CELL_PREFIX = /^\/cell-models/;

export function ModelsLegacyRedirect() {
  const location = useLocation();
  const path = location.pathname
    .replace(BATTERY_PREFIX, "/models/battery")
    .replace(CELL_SPECS_PREFIX, "/models/cell")
    .replace(CELL_PREFIX, "/models/cell");

  return <Navigate replace to={`${path}${location.search}`} />;
}
